import { type ReactNode, useEffect, useState } from 'react'
import clsx from 'clsx'
import { getUrlFromAvatarImage } from 'components/common/AvatarImage'
import { SeriesStackIcon } from './series-stack-icon'

interface SeriesAvatarProps {
	/** The series' uploaded image (its parent event's avatar), if any. */
	avatarUrl?: string | null
	alt?: string
	/** Sizes the image (e.g. `size-10`). */
	className?: string
	/** Applied to the fallback icon, e.g. `scale-75` to fit a smaller box. */
	iconClassName?: string
	/** Shown instead of the series icon when there is no image (e.g. the Loyalink logo on invites). */
	fallback?: ReactNode
}

/** The series' image, or the fallback (the series icon by default) when none was uploaded or it fails to load. */
export function SeriesAvatar({ avatarUrl, alt = '', className, iconClassName, fallback }: Readonly<SeriesAvatarProps>) {
	const [failed, setFailed] = useState(false)

	useEffect(() => {
		setFailed(false)
	}, [avatarUrl])

	if (!avatarUrl || failed) {
		if (fallback !== undefined) return <>{fallback}</>
		return (
			<div className={iconClassName}>
				<SeriesStackIcon />
			</div>
		)
	}

	return (
		<img
			src={getUrlFromAvatarImage(avatarUrl)}
			alt={alt}
			onError={() => setFailed(true)}
			className={clsx('rounded-lg object-cover', className)}
		/>
	)
}
